<template>
  <div class="quick">
	<div class="listUl">
		<ul class="hidden-sm-and-down">
		   <li class="logined"  v-show="userInfo">
			   <div class="usernamem">
				    Welcome：<a :title="UserName" href="javascript:void(0);" class="username">{{UserName}}</a>
					<a  style="cursor: pointer;color:#ffab22" @click="LoginOut">Exit</a> This System
			   </div>
			   </li>
		   <li v-show="!userInfo" class="one"><a @click="goReg()" href="javascript:void(0);"><span class="login-img"><img src="../assets/images/arrow1.png" v-if="!userInfo"></span><span class="login-text">Author Registration</span></a></li>
		   <li class="two" v-if = "userInfo?userInfo.RoleID.indexOf('Authors')!=-1:true"><a @click="goLogin(1)"  href="javascript:void(0);"><span class="login-img"><img src="../assets/images/arrow2.png" v-if="!userInfo"></span><span class="login-text">{{userInfo?"Go":""}}Submission Inquiry</span></a></li>
		   <li class="four" v-if = "userInfo?userInfo.RoleID.indexOf('Experts')!=-1:true"><a @click="goLogin(3)"><span class="login-img"><img src="../assets/images/arrow3.png" v-if="!userInfo"></span><span class="login-text">{{userInfo?"Go":""}}Reviewer Login</span></a></li>
		    <li class="three" v-if = "userInfo?userInfo.RoleID.indexOf('Editors')!=-1:true"><a @click="goLogin(2)"><span class="login-img"><img src="../assets/images/arrow4.png" v-if="!userInfo"></span><span class="login-text">{{userInfo?"Go":""}}Editor Login</span></a></li>
		 </ul>
		 <div class="clearfix"></div>
		 <ul class="hidden-md-and-up m_login">
		   <li v-show="!userInfo"><a style="cursor: pointer;" @click="goReg()">REGISTRATION</a></li>
		   <li v-show="userInfo"><a style="cursor: pointer;" @click="LoginOut">Exit This System</a></li>
		   <li v-for="(item,index) in Systemlist" :Key="item" v-if = "userInfo?userInfo.RoleID.indexOf(type[index])!=-1:true" @click="goLogin(index+1)"><a href="javascript:void(0);">{{item}}</a></li>
		 </ul>
	</div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
    export default {
        name: "Logincontrol",
      data(){
          return{
            Systemlist:[
              "SUBMISSION",
			  "EDITOR LOGIN",
			  "PEER REIVEW"
            ],
			userInfo:"",
			UserName:"",
			type:["Authors","Editors","Experts"]
          }
      },
	  created() {
	  	this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"))
		if(this.userInfo){
			this.UserName = this.userInfo.UserName
		}
	  },
	  methods:{
		  LoginOut(){
			//退出登录
			window.localStorage.removeItem("userInfo")
			sessionStorage.removeItem('eqcode');
			location.reload() 
		  },
		  goLogin(num){
			 
			  if(window.localStorage.getItem("userInfo")){
				 if(num==1){
				 	var urldomain = "/author/#/";
				 	window.location.href=urldomain;
				    return  						
				  }else if(num==2){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/editor/#/editor/Index";
				 	 window.location.href=urldomain;
				  return  					       
				  }else if(num==3){
				 	 const hostname = document.location.hostname;
				 	 var urldomain = "/expert/#/examine-manuscripts";
				 	 window.location.href=urldomain;
				 	 return 					 	 
				 	 }	
			  }else{
				  //num 1-作者 2-编辑办公 3-专家审稿
				  window.sessionStorage.setItem("Login",num)
				  if(num == 1){
					  window.location.href = 'http://nauxb.njau.edu.cn/#/Login?Login=1'; 
				  }
				  if(num == 2){
					  window.location.href = 'http://nauxb.njau.edu.cn/#/Login?Login=2'; 
				  }
				  if(num == 3){
					  window.location.href = 'http://nauxb.njau.edu.cn/#/Login?Login=3'; 
				  }
			  }
		  },
		  goReg(){
			  window.location.href = 'http://nauxb.njau.edu.cn/#/regist'; 
			//   this.$router.push({
			//     path: 'http://xb.xatu.edu.cn/#/regist'// 跳转至登录
			//   })
		  }
	  }
    }
</script>

<style scoped>
.logined{
	    font-size: 14px;
}
.login-img{ padding-left: 25px; width: 25px; position: relative; top: 3px; display: inline-block;}
.login-text{ position: relative; top: -1px; left:6px}
.usernamem{
	width: 80%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
	white-space: nowrap;
	padding: 0 15px;
}
@media (max-width:768px){
.quick{ margin-top:10px !important; margin-bottom: 10px !important;}
}


@media (max-width:768px){
.logined{ background: #6689c3 !important;}
}
.m_login li:first-child{ background: url(../assets/images/arrow1.png) no-repeat 25px center;}
.m_login li:nth-child(3){ background: url(../assets/images/arrow2.png) no-repeat 25px center;}
.m_login li:nth-child(4){ background: url(../assets/images/arrow4.png) no-repeat 25px center;}
.m_login li:nth-child(5){ background: url(../assets/images/arrow3.png) no-repeat 25px center;}
.m_login li{padding-left:55px;}
.m_login li:nth-child(24){padding-left: 10px;}
</style>
